import PageMeta from 'components/PageMeta/PageMeta';
import { FAMILY_APPLICATION_STEPS } from '../../familyApplicationConstants';
import { Spin } from 'antd';
import { useEffect, useState } from 'react';
import { familyService } from 'services';
import { getNextStep, getPreviousStep, stepConfigAtom } from '../../atoms';
import { useAtomValue } from 'jotai';
import { Banner } from 'components/ui/Banner';
import DocumentationRequirementCard from '../../__components/DocumentationRequirementCard';
import { combineDocumentationRequirements } from 'services/family.service';
import { CardTitle } from 'components/Card/Card';
import { getApplicantFirstName } from '../../utils';
import { ApplicationWizardActions } from 'components/application-wizards/ApplicationWizardActions';

export function FamilyApplicationDocuments({ application, loading, setStep, readOnly = false }) {
  const stepConfig = useAtomValue(stepConfigAtom);

  // Load application files
  const [files, setFiles] = useState(null);
  useEffect(() => {
    if (application?.id) {
      familyService.getApplicationFiles(application.id).then((applicationFiles) => {
        setFiles(applicationFiles || []);
      });
    }
  }, [application?.id]);

  // Load spouse documentation requirements
  const [documentationRequirements, setDocumentationRequirements] = useState(null);
  useEffect(() => {
    if (application?.id && application?.applicant?.id) {
      familyService
        .getApplicantDocumentationRequirements(application.id, application.applicant?.id)
        .then((requirements) => {
          const _combinedRequirements = combineDocumentationRequirements(requirements);
          setDocumentationRequirements(_combinedRequirements);
        })
        .catch((error) => {
          console.error('Failed to load spouse documentation requirements:', error);
          setDocumentationRequirements([]);
        });
    }
  }, [application?.id, application?.applicant?.id]);

  if (loading || files === null) {
    return (
      <div className="p-8">
        <Spin className="table m-auto" />
      </div>
    );
  }

  return (
    <>
      <PageMeta title="Documents" />

      <div className="p-7">
        <Banner
          question={`${getApplicantFirstName(application?.applicant)}'s documents we’ll need`}
          guidance="Based on your answers, here's what you'll need"
          className="mb-12"
        />

        {/* Dynamic Documentation Cards */}
        {documentationRequirements?.map((requirement, index) => (
          <DocumentationRequirementCard
            key={requirement.fileType}
            requirement={requirement}
            files={files}
            setFiles={setFiles}
            application={application}
            readOnly={readOnly}
            title={<CardTitle title={requirement.title} icon="📋" />}
            showRequirementStatus
            className={index > 0 ? 'mt-10' : ''}
          />
        ))}
      </div>

      <ApplicationWizardActions
        backButtonProps={{
          onClick: () => {
            // Use getPreviousStep to determine the previous step
            const previousStep = getPreviousStep(FAMILY_APPLICATION_STEPS.DOCUMENTS, application, stepConfig);

            setStep({
              applicationId: application?.id,
              newStep: previousStep,
            });
          },
        }}
        nextButtonProps={{
          text: 'Next',
          onClick: () => {
            // Use getNextStep to determine the next step
            const nextStep = getNextStep(FAMILY_APPLICATION_STEPS.DOCUMENTS, application, stepConfig);
            setStep({
              applicationId: application?.id,
              newStep: nextStep,
            });
          },
        }}
      />
    </>
  );
}
